module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-35.a6ec53db.svg";